import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { CreateComponent } from './create/create.component';
import { EditComponent } from './edit/edit.component';
import { NotFoundComponent } from './not-found/not-found.component';
import { ViewComponent } from './view/view.component';
import { authGuard, Permission } from './shared/services/auth-guard.service';
import { DefaultComponent } from './default/default.component';
import { BulkEditComponent } from './bulk/edit/bulk.edit.component';

export enum Routing {
  doc = 'doc',
  configured = 'configured',
  create = 'create',
  history = 'history',
  root = '',
  view = 'details/:id/view',
  edit = 'details/:id/edit',
  bulkEdit = 'bulk/edit',
  notFound = '404',
}

const routes: Routes = [
  {
    path: Routing.root,
    component: DefaultComponent,
    pathMatch: 'full',
    canActivate: [authGuard],
    data: { requiredPermissions: [Permission.read] },
  },
  {
    path: Routing.doc,
    redirectTo: '/doc/index.html',
  },
  {
    path: Routing.create,
    component: CreateComponent,
    canActivate: [authGuard],
    data: { requiredPermissions: [Permission.create] },
  },
  {
    path: Routing.edit,
    component: EditComponent,
    canActivate: [authGuard],
    data: { requiredPermissions: [Permission.update] },
  },
  {
    path: Routing.view,
    component: ViewComponent,
    canActivate: [authGuard],
    data: { requiredPermissions: [Permission.read] },
  },
  {
    path: Routing.bulkEdit,
    component: BulkEditComponent,
    canActivate: [authGuard],
    data: { requiredPermissions: [Permission.update] },
  },
  {
    path: Routing.notFound,
    component: NotFoundComponent,
  },
  {
    path: '**',
    redirectTo: '/' + Routing.root,
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
